import { useState } from 'react';
import axiosInstance from '../../api';
import { useDispatch } from 'react-redux';
import { setError, setErrorData } from '../../../store/common/generalSlice';

const useApi = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const request = async (url, method, data = null) => {
    setIsLoading(true);
    dispatch(setError(''));
    dispatch(setErrorData(null));

    try {
      const response = await axiosInstance({ url, method, data });

      const status = response?.status ?? response?.data?.status;

      if ([200, 201, 204].includes(status)) {
        return response.data ?? { success: true };
      }

      // Optional: handle non-success status here
      dispatch(setError('Unexpected response status'));
    } catch (err) {
      const error = err?.response;
      dispatch(setErrorData(error));
      dispatch(setError(error?.data?.message || error?.data?.error?.message || 'An error occurred'));
    } finally {
      setIsLoading(false);
    }
  };

  return { request, isLoading };
};

export default useApi;
